import React, { useState } from 'react';
import "../../Styles/yellocalfcss/SendInvoice.css";
import { Button, Form } from 'react-bootstrap';

function SendFeeInvoice() {
  const [message, setMessage] = useState('');

  const handleSendClick = () => {
    if (message.trim() === '') {
      alert('Please enter an additional message.');
      return;
    }

    alert(`Message sent: ${message}`);
    setMessage('');
  };

  return (
    <div className="SendInvoice-wrapper">
      <div className="SendInvoice-top-bar">
        <div className="SendInvoice-page-title">Send Fee Invoice balance</div>
        <div className="SendInvoice-sms-balance">
          Available SMS Balance is : <span className="SendInvoice-balance-box">1227.00</span>
        </div>
      </div>

      <div className="SendInvoice-content-box">
        <div className="SendInvoice-left-box">
          <p>Greetings Amit,</p>
          <p>Your outstanding balance for Ashutose, admission number : fsdf35346 is $ 3700. Due date is 2024-06-10</p>
        </div>
        <div className="SendInvoice-right-box">
          <Form>
            <Form.Group controlId="additionalMessage">
              <Form.Label className="SendInvoice-label">
                Additional Message <span className="SendInvoice-required">*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </Form.Group>
            <Button variant="primary" className="SendInvoice-send-btn" onClick={handleSendClick}>Send</Button>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default SendFeeInvoice;
